module.exports = __webpack_public_path__ + "static/img/background.ea12757.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.jpg
// module id = ycj+
// module chunks = 1